export const COLOR_NAVI = '#213F5A';
export const COLOR_GOLD = '#DAD651';
